import { h, VNode, Fragment, ComponentChildren, FunctionComponent, toChildArray } from "preact"; /** @jsx h */
import { clsx } from 'clsx';
import { ISectionProps } from "./Section";

export type IFixedProps = {
    children?: Array<VNode<ISectionProps>> | VNode<ISectionProps>;

};

export const Fixed = (props: IFixedProps) => {

    return (
        <Fragment>
            { props.children }   
        </Fragment>
    );
}